import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var NorwegianCharacters = /*#__PURE__*/function (NorwegianCharacters) {
  NorwegianCharacters["\xE6"] = "ae";
  NorwegianCharacters["\xF8"] = "o";
  NorwegianCharacters["\xE5"] = "a";
  return NorwegianCharacters;
}(NorwegianCharacters || {});
const toKebabCaseWithoutNorwegianCharacters = str => str.replace(/[æøå]/g, char => NorwegianCharacters[char]).replace(/[^a-zA-Z0-9\s]/g, '').split(/\W/).join('-');
export default toKebabCaseWithoutNorwegianCharacters;